export const OVERVIEW_STORAGE_KEY = "adminOverviewLayout";

export const DEFAULT_OVERVIEW_WIDGETS = {
  kpis: true,
  calendar: true,
  approvalQueue: true,
  finance: true,
  employeeSnapshot: true,
};

export const OVERVIEW_WIDGET_LABELS = {
  kpis: "상단 요약 카드",
  calendar: "월간 승인 캘린더",
  approvalQueue: "승인 대기",
  finance: "급여 현황",
  employeeSnapshot: "직원 및 일급 요약",
};
